import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import ExpandingBlock from 'rise-ui/components/expanding-block.gjs';
import Sticky from 'rise-ui/components/sticky.gjs';
import Help from 'rise-ui/components/time-series/selection/help.gjs';
import set from 'rise-ui/helpers/set.js';
import sticky from 'rise-ui/modifiers/sticky.js';

export default class TimeSeriesSelectionInstructionsComponent extends Component {
  @tracked isStickyHelpShown = false;
  @tracked isHelpShown = false;

  <template>
    <Sticky @name="help">
      <ExpandingBlock
        @button={{true}}
        @onToggle={{set this "isStickyHelpShown"}}
      >
        <:head>
          {{if this.isStickyHelpShown "Hide" "Show"}} Instructions
        </:head>
        <:body>
          <Help />
        </:body>
      </ExpandingBlock>
    </Sticky>

    <ExpandingBlock
      @button={{true}}
      @onToggle={{set this "isHelpShown"}}
      {{sticky activate="help"}}
    >
      <:head>
        {{if this.isHelpShown "Hide" "Show"}} Instructions
      </:head>
      <:body>
        <Help />
      </:body>
    </ExpandingBlock>
  </template>
}
